import { randomBetween, seededRandom } from "./seeded-random";
import {
  chaikin,
  resampleByArcLength,
  type SketchPoint,
} from "./stroke-points";

const AGENT_INK_SPACING_PX = 2.5;

/** Smooths raw agent geometry into an evenly spaced pen stroke with a gentle
 * pressure wave. Pressure is indexed by arc length (not point index), so a
 * growing prefix of the same raw path keeps its leading points stable and the
 * stroke does not jitter while it is drawn. Both endpoints are kept. `flat`
 * holds pressure at 1, for the marker's even band. */
export function agentInkStroke(
  raw: readonly SketchPoint[],
  seed: string,
  { flat = false }: { flat?: boolean } = {},
): SketchPoint[] {
  const phase = randomBetween(seededRandom(seed), 0, Math.PI * 2);
  const points = resampleByArcLength(chaikin(raw, 2), AGENT_INK_SPACING_PX);
  let traveled = 0;
  return points.map((point, index) => {
    if (index > 0) {
      const previous = points[index - 1]!;
      traveled += Math.hypot(point.x - previous.x, point.y - previous.y);
    }
    return {
      x: point.x,
      y: point.y,
      p: flat ? 1 : 0.8 + 0.2 * Math.sin(traveled * 0.014 + phase),
    };
  });
}
